import React from "react";

const RegistrationsPanel = ({ registeredEntries, entryTypeLabel }) => {
  const entryTypeLabelSingle = entryTypeLabel.endsWith("s")
    ? entryTypeLabel.slice(0, -1)
    : entryTypeLabel;

  return (
    <div className="card table-card">
      <div className="card-header">
        <h3>Registrations</h3>
        <span className="chip">{registeredEntries.length} total</span>
      </div>
      {registeredEntries.length === 0 ? (
        <div className="empty-inline">No registrations yet.</div>
      ) : (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>{entryTypeLabelSingle}</th>
                <th>ID</th>
                <th>Members</th>
              </tr>
            </thead>
            <tbody>
              {registeredEntries.map((entry) => (
                <tr key={entry.id}>
                  <td>{entry.name}</td>
                  <td className="table-subtitle">{entry.id}</td>
                  <td>
                    {entry.type === "player"
                      ? "Solo"
                      : `${entry.memberIds?.length || 0} players`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RegistrationsPanel;
